import {useSelector} from 'react-redux';

import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import appContent from '@/services/content/appContent';
import {selectIsHolderConnectedToIot, selectIsSelectedDeviceConnectedToIot} from '@/state/selectors/device';
import {selectIsHolderConnected} from '@/state/selectors/mw';

const HolderDetectedBanner = ({className}) => {
    const isSelectedDeviceConnectedToIot = useSelector(selectIsSelectedDeviceConnectedToIot);
    const isHolderConnected = useSelector(selectIsHolderConnected);
    const isHolderConnectedToIot = useSelector(selectIsHolderConnectedToIot);
    const icon = appContent.getHolderDetectedInfoIcon();

    if (!icon || isHolderConnectedToIot || !isHolderConnected || !isSelectedDeviceConnectedToIot) return null;

    const {title, description} = icon || {};

    return (
        <div className={className}>
            <div
                className='flex w-full items-center gap-2 rounded-xl bg-romance p-4 text-start ml:bg-primary-dark-5'
                role='status'
                aria-live='polite'
            >
                <RemoteIconV2 icon={icon} className='h-8 w-8' />
                <div>
                    <h2 className='mb-0 text-16 font-bold'>{title}</h2>
                    <p className='text-14 tracking-04'>{description}</p>
                </div>
            </div>
        </div>
    );
};

export default HolderDetectedBanner;
